export default __webpack_public_path__ + "static/media/AGC_2024_R2_QP_Class_5.c379bd09.pdf";